module.exports = "https://web-assets.ifttt.com/packs/media/access_applet_card/close-49db9284.svg";